import _ from 'lodash'
import produce from 'immer'
import { Comment } from '../../types'
import { NormalizedCommentsWithDeps } from '../types'

// Historically, some comments were saved into the db with broken state - this function
// adjusts them accordingly. It probably should not be done on FE, but it is :)
export const fixBrokenComments = ({
  commentsById,
  authorsById
}: NormalizedCommentsWithDeps): NormalizedCommentsWithDeps => {
  return {
    authorsById,
    commentsById: _.mapValues(commentsById, comment => fixBrokenComment(comment!))
  }
}

// Historically, some comments were saved into the db with broken state - this function
// adjusts them accordingly. It probably should not be done on FE, but it is :)
export const fixBrokenComment = (comment: Comment): Comment => {
  return produce(comment, draft => {
    if (comment.resolved) {
      draft.status = 'resolved'
    }
  })
}
